import { render } from "./KeyIcon.vue?vue&type=template&id=3bb85d10"
import script from "./KeyIcon.vue?vue&type=script&lang=js"
export * from "./KeyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__